module.exports = __webpack_public_path__ + "img/xuqiuguangchang3.39bbd263.png";